module.exports = __webpack_public_path__ + "img/icon_close.0c70516a.svg";